import tracker, { allErrorTrackers, allTrackers } from '@cx/analytics'

export default tracker(allTrackers, allErrorTrackers)
